import React, { FC, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "src/constants/fontAwesomeIcons";
import { INavItem } from "..";
import { Tooltip } from "src/components/Tooltip";

import "./NewNavigation.scss";

interface INewNavigationTabProps {
    navItem: INavItem;
}

const NewNavigationTab: FC<INewNavigationTabProps> = ({ navItem }) => {
    //
    // -- Hooks --
    const location = useLocation().pathname;

    //
    // -- States --
    const [width, setWidth] = useState(window.innerWidth);

    // Sets the width state to the users screen width
    // This is used to determine whether to show the tooltip or not
    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleOnClickEvent: React.MouseEventHandler<HTMLElement> = (
        event
    ) => {
        rippleEffect(event);
    };

    const rippleEffect = (
        event: React.MouseEvent<HTMLElement, MouseEvent>
    ) => {
        let ripple = document.createElement("span");

        // Add ripple class to span
        ripple.classList.add("ripple");

        // Add span to the button
        event.currentTarget.appendChild(ripple);

        // Get position of X
        let x = event.clientX - event.currentTarget.offsetLeft;

        // Get position of Y
        let y = event.clientY - event.currentTarget.offsetTop;

        // Position the span element
        ripple.style.left = `${x}px`;
        ripple.style.top = `${y}px`;

        // Remove span after 0.3s
        setTimeout(() => {
            ripple.remove();
        }, 300);
    };

    const isActive = () => {
        const baseRoute = location.split("/")[1];
        return navItem.url !== undefined && ("/" + baseRoute)
            .toLowerCase()
            .includes(navItem.url.toLowerCase());
    };

    const content = <>
        {navItem.icon && <FontAwesomeIcon icon={navItem.icon} fixedWidth />}
        {navItem.title && navItem.title !== "Search" ? (
            <span className="navigation-tab-title">{navItem.title}</span>
        ) : null}
    </>;
    const className = `navigation-tab-transition ${
        isActive() ? "navigation-tab-selected" : "navigation-tab"
    }`;
    const navigationTab = navItem.url ? (
        <Link
            className={className}
            aria-label={navItem.title ?? "Navigation"}
            to={navItem.url}
            target={navItem.target}
            rel={navItem.target === "_blank" ? "noopener noreferrer" : undefined}
            onClick={handleOnClickEvent}
        >
            {content}
        </Link>
    ) : (
        <button
            type="button"
            className={className}
            aria-label={navItem.title ?? "Navigation"}
            onClick={handleOnClickEvent}
        >
            {content}
        </button>
    );

    return (
        <Tooltip asChild content={width < 1601 ? navItem.title : undefined} position="bottom">
            {navigationTab}
        </Tooltip>
    );
};

export default NewNavigationTab;
